<template>
    <v-row>

        <h4 class="red-underline">CONTACTE</h4>
        <GridTabContacte @selection-changed="handleSelectionChanged"/>
        <!-- <GridContacts :ID="selectedRow"/> -->

      <!-- <v-col cols="6" >
        <h4 class="red-underline">OPORTUNITATI</h4>
        <GridOportunitati :ContactID="selectedRow"/>
      </v-col> -->
    </v-row>
  </template>
  
  <script lang="ts">


  import {defineComponent} from 'vue'
  import GridOportunitati from './GridOportunitati.vue'
  import GridContacts from './GridContacts.vue';
import GridTabContacte from './GridTabContacte.vue';
  
  export default defineComponent({
    components: {
      GridOportunitati,
      GridTabContacte
    },
    data() {
      return {
        selectedRow: null as any
      }
    },
    methods: {
      handleSelectionChanged(selectedRow: any) {
      this.selectedRow = selectedRow.ID;
      //this.$router.push('crm-contact-details');
      },
    }
  });
  </script>
  
  <style scoped>
  .red-underline {
    text-decoration: underline;
    text-decoration-color: red;
  }
  </style>
  